// Query strings for the page-level cross-pair task fetch.
//
// The page-scoped subscriptions reuse the strings defined in
// `src/components/tasks/graphql.js` (TASK_CREATED_FOR_PAIR /
// TASK_UPDATED_FOR_PAIR / TASK_DELETED_FOR_PAIR) so we don't duplicate
// the field selections in two places.

const TASK_FIELDS = `
  taskId reportId managerId assignee
  title description
  status priority dueDate
  createdAt updatedAt completedAt
  createdBy isOrphaned
`

// Used by the nav-bar badge — "what's on my plate". Returns only tasks
// where the viewer is the assignee, fetched via the byAssigneeStatus GSI.
export const TASKS_ASSIGNED_TO_ME = `
  query TasksAssignedToMe($statusFilter: String) {
    tasksAssignedToMe(statusFilter: $statusFilter) {
      ${TASK_FIELDS}
    }
  }
`

// Used by the Tasks page — fans out across every active pair the caller
// is part of so the "Others" / "Anyone" assignee filters can return real
// data. (Under tasksAssignedToMe alone, those filters were always empty
// because the result set only contained the viewer's own assignments.)
export const TASKS_FOR_MY_PAIRS = `
  query TasksForMyPairs($statusFilter: String) {
    tasksForMyPairs(statusFilter: $statusFilter) {
      ${TASK_FIELDS}
    }
  }
`
